import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../../shared/library/breadcrumbs';

const Breadcrumbs = ({tool}) => {
  const items = [{name: 'Home', path: '/categories'}];
  if (tool.layer) {
    items.push({name: tool.layer.name, path: `/${tool.layer.slug}`});
  }
  if (tool.category) {
    items.push({name: tool.category.name, path: `/${tool.category.slug}`});
  }
  if (tool.function) {
    items.push({name: tool.function.name, path: `/${tool.function.slug}`});
  }
  return <Breadcrumb items={items} />;
};

Breadcrumbs.propTypes = {
  tool: PropTypes.object
};

export default Breadcrumbs;
